import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';

const FeedStatusFilters = ({ filters, onFilterChange }) => {
  const handleInputChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: value
    });
  };

  const clearFilters = () => {
    onFilterChange({
      status: '',
      feedType: '',
      startDate: '',
      endDate: '',
      createdBy: ''
    });
  };

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'processing', label: 'Processing' },
    { value: 'completed', label: 'Completed' },
    { value: 'failed', label: 'Failed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const feedTypeOptions = [
    { value: '', label: 'All Feed Types' },
    { value: 'POST_INVENTORY_AVAILABILITY_DATA', label: 'Inventory Availability' },
    { value: 'POST_PRODUCT_DATA', label: 'Product Data' },
    { value: 'POST_PRODUCT_PRICING_DATA', label: 'Product Pricing' },
    { value: 'POST_ORDER_FULFILLMENT_DATA', label: 'Order Fulfillment' },
    { value: 'POST_FLAT_FILE_LISTINGS_DATA', label: 'Flat File Listings' }
  ];

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div className="flex items-center mb-4">
        <FunnelIcon className="h-5 w-5 text-gray-400 mr-2" />
        <h3 className="text-lg font-medium text-gray-900">Filters</h3>
        <button
          onClick={clearFilters}
          className="ml-auto text-sm text-indigo-600 hover:text-indigo-500"
        >
          Clear all
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Status Filter */}
        <div>
          <label htmlFor="status" className="block text-sm font-medium text-gray-700">
            Status
          </label>
          <select
            id="status"
            value={filters.status}
            onChange={(e) => handleInputChange('status', e.target.value)}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          >
            {statusOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Feed Type Filter */}
        <div>
          <label htmlFor="feedType" className="block text-sm font-medium text-gray-700">
            Feed Type
          </label>
          <select
            id="feedType"
            value={filters.feedType}
            onChange={(e) => handleInputChange('feedType', e.target.value)}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          >
            {feedTypeOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Start Date Filter */}
        <div>
          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
            Start Date
          </label>
          <input
            type="date"
            id="startDate"
            value={filters.startDate}
            onChange={(e) => handleInputChange('startDate', e.target.value)}
            className="mt-1 block w-full pl-3 pr-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          />
        </div>

        {/* End Date Filter */}
        <div>
          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
            End Date
          </label>
          <input
            type="date"
            id="endDate"
            value={filters.endDate}
            onChange={(e) => handleInputChange('endDate', e.target.value)}
            className="mt-1 block w-full pl-3 pr-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          />
        </div>

        {/* Created By Filter */}
        <div>
          <label htmlFor="createdBy" className="block text-sm font-medium text-gray-700">
            Created By
          </label>
          <input
            type="text"
            id="createdBy"
            value={filters.createdBy}
            onChange={(e) => handleInputChange('createdBy', e.target.value)}
            placeholder="Search by creator"
            className="mt-1 block w-full pl-3 pr-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          />
        </div>
      </div>
    </div>
  );
};

export default FeedStatusFilters;